import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const TimezoneContext = createContext({ timezone: null, source: null, refresh: () => {} });

const TZ_STORAGE_KEY = 'bbc_effective_timezone';

export function TimezoneProvider({ children }) {
  const [timezone, setTimezone] = useState(() => localStorage.getItem(TZ_STORAGE_KEY) || null);
  const [source, setSource] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/timezone/user-effective`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setTimezone(data.effective_timezone);
        setSource(data.source);
        localStorage.setItem(TZ_STORAGE_KEY, data.effective_timezone);
      }
    } catch (e) {
      console.error('Failed to fetch timezone:', e);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <TimezoneContext.Provider value={{ timezone, source, refresh }}>
      {children}
    </TimezoneContext.Provider>
  );
}

/**
 * Hook to get the user's effective timezone.
 * Returns { timezone: string, source: string, refresh: () => void }
 */
export function useTimezone() {
  return useContext(TimezoneContext);
}

/**
 * Get the effective timezone synchronously (reads from localStorage).
 * Use in utility functions that can't use hooks.
 */
export function getEffectiveTimezone() {
  return localStorage.getItem(TZ_STORAGE_KEY) || 'Africa/Lagos';
}
